//components
import { PillLink } from '@/containers-ai/Buttons';

//styles
import { EndCTASection, Title, TitleHighlight } from './EndCTA.styles';
import { Container } from '@/components/Grid';

export function EndCTA({ variant = 'top', content }) {
  return (
    <EndCTASection
      id={variant === 'top' ? 'cta' : undefined}
      $variant={variant}
    >
      <Container>
        <Title>
          {content.title}
          <TitleHighlight>{content.titleHighlight}</TitleHighlight>
        </Title>
        <PillLink
          href={content.ctaHref ?? '/contact/#contact-form'}
          style={{ fontSize: '16px', padding: '16px 32px' }}
          className="qlf-btn-3"
        >
          {content.ctaLabel}
        </PillLink>
      </Container>
    </EndCTASection>
  );
}
